/**
 * My API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EnergyConsumptionProductionKWhPerH } from './energyConsumptionProductionKWhPerH';


export interface StatusCodeValueEnergyConsumptionProductionKWhPerH { 
    value?: EnergyConsumptionProductionKWhPerH;
    status_code?: number;
}

